import { ApiError } from '~/types/ApiError';
import { getCustomError } from '~/utils/codedError';

const getCustomErrorMessageFromApiError = (err: ApiError) =>
  err.response?.data?.error;

export const parseApiError = (err: any) => {
  const responseCustomErrorMessage = getCustomErrorMessageFromApiError(err);
  return getCustomError(responseCustomErrorMessage);
};
